/*********************************************************************
 * 
 * WARNING: This shader class is automatically generated, any manual 
 * edits will be lost.
 * Last generated: 2020-04-03T14:33:08.693Z
 * 
 ********************************************************************/
import { ShaderBase } from '../ShaderBase';

export type AdditiveBlendShaderUniforms = {
	uSourceTextureSampler: WebGLUniformLocation,
	uBlendTextureSampler: WebGLUniformLocation,
	uAlpha: WebGLUniformLocation
};

export type AdditiveBlendShaderAttributes = {
	aVertexPosition: number
};

export type AdditiveBlendShaderSettings = ('USE_SOURCE_TEXTURE' | 'SET_ALPHA')[];

export class AdditiveBlendShader extends ShaderBase<AdditiveBlendShaderUniforms, AdditiveBlendShaderAttributes> {

    private static fragmentShaderSource = `
#ifdef SPI_USE_SOURCE_TEXTURE
uniform sampler2D uSourceTextureSampler;
#endif

uniform sampler2D uBlendTextureSampler;
varying vec2 vTextureCoord;

#ifdef SPI_SET_ALPHA
uniform float uAlpha;
#endif

void main()
{
    #ifdef SPI_SET_ALPHA
    vec4 color = vec4(texture2D(uBlendTextureSampler, vTextureCoord).rgb, uAlpha);
    #else
    vec4 color = texture2D(uBlendTextureSampler, vTextureCoord);
    #endif

    #ifdef SPI_USE_SOURCE_TEXTURE
    gl_FragColor = texture2D(uSourceTextureSampler, vTextureCoord) + color;
    #else
    gl_FragColor = color; 
    #endif
}
`;

    private static vertexShaderSource = `
// xy = vertex position in normalized device coordinates ([-1,+1] range).
attribute vec2 aVertexPosition;

varying vec2 vTextureCoord;

const vec2 scale = vec2(0.5, 0.5);

void main()
{
    vTextureCoord  = aVertexPosition * scale + scale; // scale vertex attribute to [0,1] range
    gl_Position = vec4(aVertexPosition, 0.0, 1.0);
}
`;

    protected get warnAttributeMismatch(): boolean {
        return false;
    }
    constructor(gl: WebGLRenderingContext, settings: AdditiveBlendShaderSettings) {
        super(gl, AdditiveBlendShader.fragmentShaderSource, AdditiveBlendShader.vertexShaderSource, settings);
    }

}
        